module.exports = __webpack_public_path__ + "img/success.790f43fb.svg";